'use strict';

/*
DOCUMENT ME
*/

define('modules/module.compare.specific',[
  'jquery',
  './module',
  'txt!./module.compare.hbs',
  'txt!./module.loader.hbs',
  'storageUtil',
  'zipTools',
  'lib/util/zip',
  'lib/page-cache',
  'lib/imgix',

  // Side Effect Includes
  'lib/transforms/series.mapByCode'
], function (
  $,
  Module,
  txtTemplate,
  txtModuleLoader,
  storageUtil,
  zipTools,
  zip,
  PageCache,
  imgix
) {
  var __tmplLoader = Handlebars.compile(txtModuleLoader);
  var __tmplBody = Handlebars.compile(txtTemplate);

  var CompareSpecificModule = Module.extend({
    template: __tmplLoader,
    events: function () {
      return Object.assign({}, Module.prototype.events, {
        'click .module-cta-0': 'onViewClicked'
      });
    },

    staticData: {
      all: {
        image: {
          '1x1': imgix('/assets/img/module/compare/compare-dynamic-1.jpg', { w: 310 }),
          '2x1': imgix('/assets/img/module/compare/compare-dynamic-2.jpg', { w: 393 }),
          '3x1': imgix('/assets/img/module/compare/compare-dynamic-3.jpg', { w: 636 })
        },
        subtextIcon: '/assets/img/module/compare/icon-comparison.svg',
      },
      en: {
        subtext: 'Compare Vehicles',
        copyExtended: {
          intro: 'versus',
          title: 'The Competition'
        }
      },
      es: {
        subtext: 'Comparar Vehículos',
        copyExtended: {
          intro: 'Contra',
          title: 'la competencia'
        }
      }
    },

    initialize: function (canvas, config, idx) {
      Module.prototype.initialize.apply(this, arguments);
      var self = this;
      if (config.data && config.data.model) {
        PageCache.await('series.map').then(function (seriesMap) {
          self.drawPage(seriesMap);
        });
      }
    },

    drawPage: function (seriesMap) {
      var model = this.getConfig().data.model;
      this.staticData.es.headline = 'Comparar ' + seriesMap[model.series].series_display_name + ' ' + model.year;
      this.staticData.en.headline = 'Compare the ' + model.year + ' ' + seriesMap[model.series].series_display_name;
      this.setTemplate(__tmplBody);
      this.updateModuleDataLayer();
    },

    getTemplateContext: function (layout) {
      var ctx = $.extend({}, this.staticData.all, this.staticData[this.getCanvas().getLang()], this.getConfig().data);

      // Update the actions (compare to links)
      ctx.actions = ctx.compareTo;
      if (layout === '1x1' && ctx.actions && ctx.actions.length) {
        ctx.actions = ctx.actions.slice(0, 1);
      }

      // Set the image (if present due to the MCE)
      if (ctx.model) {
        ctx.compareImg = '/assets/img/vehicles/' + ctx.model.series + '/default-offer-detail.png';
        ctx.compareImgAlt = ctx.model.year + ' ' + ctx.model.series;
      }
      return ctx;
    },

    onViewClicked: function (e) {
      // this.updateModuleDataLayer();
      if (storageUtil.getTDA() === 'WWW') {
        // If we are on WWW, show the zip dialog
        e.preventDefault();
        zipTools.promptUserForZip(zip.getCookiedDefaultFallback(), $(e.currentTarget).attr('href'));
      }
    },

    // there's a default dataLayer output on parent .module
    // take that and supplement it with our vehicle data.
    updateModuleDataLayer: function () {
      var dataToAdd = {
        series_code: this._config.data.model.series,
        series_brand: 'Toyota',
        series_year: this._config.data.model.year,
        series_number: '',
        series_vehicleid: '',
        series_inventory_type: 'New',
        series_category: '',
        series_fuel_type: '',
        series_msrp: '',
        series_grade: this._config.data.model.trim, // not yet a configurable option via backend
        series_engine: '',
        series_transmission: '',
        series_body_style: '',
        series_packages: '',
        series_color_ext: '',
        series_color_int: '',
        series_color_ext_code: '',
        series_color_int_code: '',
        series_accessories_name: ''
      };

      var $parent = this.$el;
      var data = $parent.data('layer') || {};
      if (typeof data !== 'object') {
        data = JSON.parse(data);
      }
      // update data on parent module
      var fullData = Object.assign({}, data, dataToAdd);
      $parent.data('layer', fullData);
    },
  });

  return CompareSpecificModule;
});

